module.exports = __webpack_public_path__ + "img/figma.ee22d999.png";